import React from 'react';
import * as S from './Header2.styles';

interface IHeader2 {
  name?: string;
}


const Header2: React.FC<IHeader2> = (props) => (
  <S.Heading2 {...props}>{props.name}</S.Heading2>
);

export default Header2;